import React from 'react';
import { translate } from 'react-i18next';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import TextField from 'material-ui/TextField';

class UsableTimes extends React.Component {

  render()  {
    const {t} = this.props;

    return (
      <div className='col-xs col-md-5'>
        <span className='headerSpanStyle'>
          {t('offer.usable')}
        </span>
        <RadioButtonGroup
          name={t('offer.usable')}
          valueSelected={this.props.usableInfinitely}
          onChange={this.props.handleDiscountUseChange}>
          <RadioButton
            value={true}
            label={t('offer.infiniteTimesUse')}
            className='switchButton'
          />
          <RadioButton
            value={false}
            label={t('offer.certainTimeUse')}
            className='switchButton'
          />
        </RadioButtonGroup>
        <TextField
          floatingLabelText={t('offer.usableTimes')}
          type='number'
          placeholder={'\u221E'}
          floatingLabelFixed={true}
          inputStyle={{textAlign: 'right'}}
          min='1'
          max='99999'
          className='textFieldNextToRadio'
          value={this.props.usableTimes}
          onChange={this.props.handleDiscountUseAmountChange}
          disabled={this.props.usableInfinitely}
        />
        <div className='paddingDiv'/>
      </div>
    );
  }

}

export default translate()(UsableTimes);



// WEBPACK FOOTER //
// ./src/Offer/UsableTimes.js